//#region src/combobox/useListboxOptionOnKeyDown.ts
const useListboxOptionOnKeyDown = ({ ref, searchRef }) => {
	return (e) => {
		const listBox = ref.current?.closest("[role=\"listbox\"]");
		const currentOption = e.currentTarget;
		if (listBox) {
			const allOptions = listBox.querySelectorAll("[role=\"option\"]");
			const firstOption = allOptions[0];
			let currentTargetIndex = -1;
			allOptions.forEach((element, index) => {
				if (element === currentOption) currentTargetIndex = index;
			});
			if (e.key === "ArrowDown") {
				e.preventDefault();
				const possibleNextOption = allOptions[currentTargetIndex + 1];
				if (possibleNextOption) possibleNextOption.focus();
				else firstOption?.focus();
			}
			if (e.key === "ArrowUp") {
				e.preventDefault();
				const possibleNextOption = allOptions[currentTargetIndex - 1];
				if (possibleNextOption) possibleNextOption.focus();
				else searchRef.current?.focus();
			}
		}
	};
};
//#endregion
export { useListboxOptionOnKeyDown };
